import type { CompanyStatus } from './types.ts';

/**
 * Human-readable labels for each company status. Single source of truth shared
 * by the status badge and the admin filters so the two can never drift apart.
 */
export const COMPANY_STATUS_LABELS: Record<CompanyStatus, string> = {
  invited: 'Invited',
  in_progress: 'In progress',
  review: 'Action required',
  changes: 'Company change requested',
  compliant: 'Compliant',
  expired: 'Not Compliant',
  deactivated: 'Deactivated',
};

/** Statuses in lifecycle order — drives the order of filter dropdown options. */
export const COMPANY_STATUSES: CompanyStatus[] = [
  'invited',
  'in_progress',
  'review',
  'changes',
  'compliant',
  'expired',
  'deactivated',
];
